"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.utilityButtonPropTypes = void 0;
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _ButtonBase = require("../button/ButtonBase");
var _filterProps = require("../utils/filterProps");
var _interface = require("./interface");
const filteredButtonNonDOMProps = (0, _filterProps.filterObjectProps)(_ButtonBase.buttonNonDOMPropTypes, ['isDestructive',
//this prop is deprecated
'shouldUseResponsiveContent']);
const utilityButtonPropTypes = exports.utilityButtonPropTypes = {
  ...filteredButtonNonDOMProps,
  ..._ButtonBase.buttonBasePropTypes,
  variant: _stencilReactDesc.PropTypes.oneOf(Object.values(_interface.UtilityButtonVariant)).description('Sets the visual style of the button.'),
  colorScheme: _stencilReactDesc.PropTypes.oneOf(Object.values(_interface.UtilityButtonColorScheme)).description('Sets the color scheme for the button.')
};